import { render, staticRenderFns } from "./remoteDXSaccount.vue?vue&type=template&id=45d821ae&scoped=true&"
import script from "./remoteDXSaccount.vue?vue&type=script&lang=js&"
export * from "./remoteDXSaccount.vue?vue&type=script&lang=js&"
import style0 from "./remoteDXSaccount.vue?vue&type=style&index=0&id=45d821ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d821ae",
  null
  
)

export default component.exports